import * as React from "react";
import { Button, Glyphicon, Modal } from "react-bootstrap";
import ReactTable from "react-table";

export class ModalDetallesGlosa extends React.Component<ModalDetallesGlosaProps, any> {
    
    columns = [{
        accessor: "parametro",
        className: "table-txt-left"
    },
    {
        accessor: "valor",
        className: "table-txt-left"
    }];

    constructor(props: any) {
        super(props);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            show: false,
            table: true
        };
    }

    handleShow() {
        this.setState({show: true, detallesGlosaEmpleador: this.convertirDetalleGlosa(this.props.detalleGlosa)});
    }

    handleClose() {
        this.setState({show: false});
    }

    render() {
        return(
            <div>
                <a className={"btns btns-primary"} onClick={this.handleShow}>
                    <Glyphicon glyph={"file"}/>
                </a>
                {this.state.show && this.renderModalDetalles()}
            </div>
        );
    }

    renderModalDetalles() {
        const {nombreEmpleador, dniEmpleador}=this.props;
        return(
            <div>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{nombreEmpleador ? nombreEmpleador : `Empresa ${dniEmpleador}`}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.renderContenido()}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className={"btns btns-secondary"} onClick={this.handleClose}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    renderContenido = () => {
        return(
            <div>
                {this.renderTablaDetalles()}
            </div>
        );  
    };

    renderTablaDetalles() {
        const datosDetalles = this.construirObjetoDetalles();
        const {consecutivo, nombreTransaccion} = this.props;
        return(
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"} style={{fontSize:`15px`}}>
                        #{consecutivo} {nombreTransaccion}
                    </h2>
                </div>
                {
                    this.state.table && 
                    <ReactTable data={datosDetalles}
                            columns={this.columns}
                            sortable={false}
                            resizable={false}
                            showPagination={false}
                            className={"-highlight -striped"}
                            defaultPageSize={datosDetalles.length}/>
                }
                {
                    !this.state.table && 
                    <div style={{fontSize:'16px', marginTop:'16px'}}>
                        <b>Se ha presentado un error técnico:</b> <br/><br/>
                        {datosDetalles}
                    </div>
                }
            </div>
        );
    }

    construirObjetoDetalles = () => {
        if(this.state.table) {
            const detalles = [];
            if(this.props.codigoServicio !== 1 && this.props.codigoServicio !== 4) {
                if(this.props.npoliza) {
                    detalles.push({
                        parametro: "Póliza",
                        valor: this.props.npoliza
                    });
                }
                if(this.props.usuario) {
                    detalles.push({
                        parametro: "Usuario Gestión",
                        valor: this.props.usuario
                    });
                }
                if(this.props.emailUsuario) {
                    detalles.push({
                        parametro: "Correo Usuario Gestión",
                        valor: this.props.emailUsuario
                    });
                }
            }
            const {detallesGlosaEmpleador} = this.state;
            const objetoDetalles = Object.keys(detallesGlosaEmpleador);
            objetoDetalles.map(detalle => {
                detalles.push({
                    parametro: detalle,
                    valor: detallesGlosaEmpleador[detalle]
                });
            });
            return detalles;
        } else {
            return this.state.detallesGlosaEmpleador;
        }
    };

    convertirDetalleGlosa(detalleGlosa: string) {
        try {
            return JSON.parse(detalleGlosa);
        } catch(e) {
            this.setState({table: false});
            return detalleGlosa;
        }
    }
}

interface ModalDetallesGlosaProps {
    dniEmpleador: string,
    codigoServicio: number,
    consecutivo: number,
    nombreEmpleador: string,
    npoliza: string,
    usuario: string,
    emailUsuario: string,
    detalleGlosa: string,
    nombreTransaccion: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/componentes/ModalDetallesGlosa.tsx